import { render, staticRenderFns } from "./DGChunAdd.vue?vue&type=template&id=6fa52cb8&scoped=true&"
import script from "./DGChunAdd.vue?vue&type=script&lang=js&"
export * from "./DGChunAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa52cb8",
  null
  
)

export default component.exports